import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Use this hook when you want to create state in the location object.
 *
 * @param key Name of the state
 * @param initialValue The initial value of the state
 * @returns Array with the state on index 0 and the set function on index 1
 */

export const useLocationState = <T>(key: string, initialValue: T): [T, (t: T) => void] => {
  const { state: locationState } = useLocation();
  const navigate = useNavigate();

  const [rawState, rawSetState] = useState<T>(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (locationState as any)?.[key];
    return value ?? initialValue;
  });

  const setState = (value: T) => {
    // Replace current location with new states in history
    navigate('.', {
      state: {
        ...locationState,
        [key]: value,
      },
      preventScrollReset: true,
      replace: true,
    });
    rawSetState(value);
  };
  return [rawState, setState];
};
